export function requestNotificationPermission() {
  if (!('Notification' in window)) {
    return;
  }

  if (Notification.permission === 'granted') {
    showNotification();
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        showNotification();
      }
    });
  }
}


export function showNotification() {
  new Notification('Hello', {
    title: 'games app',
    icon: '/pwa-192x192.png' // Optional, path to the icon to be displayed with the notification.
  });
}